import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";
import { useCreateClassTemplate } from "../api/queries";
import { ClassTemplateForm } from "../ui/ClassTemplateForm";

export function ClassTemplateCreatePage() {
  const nav = useNavigate({ from: "/app/classes/templates/create" });
  const createTemplate = useCreateClassTemplate();

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Template ຄລາດສ໌", to: "/app/classes/templates" },
            { label: "ສ້າງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="flex flex-wrap items-center justify-between space-y-2">
          <div>
            <h2 className="flex items-center font-bold text-2xl tracking-tight">
              ສ້າງ Template ຄລາດສ໌
            </h2>
            <p className="text-muted-foreground">ສ້າງ template ຄລາດສ໌ໃໝ່ໃນລະບົບ.</p>
          </div>

          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/classes/templates" })}
          >
            <ArrowLeftIcon className="size-4" />
            ກັບຄືນ
          </Button>
        </div>

        <div className="mt-6 rounded-xl border bg-card p-6">
          <ClassTemplateForm
            onSubmit={async (vals) => {
              try {
                const result = await createTemplate.mutateAsync(vals);
                nav({
                  to: "/app/classes/templates/$id",
                  params: { id: result.id },
                });
              } catch (error) {
                // Error handling is done by the mutation
              }
            }}
            submitting={createTemplate.isPending}
          />
        </div>
      </Main>
    </>
  );
}
